import React from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert2 from "react-sweetalert2";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import LZString from "lz-string";
import Header from "components/Headers/Header.js";
import Api from "shared/resources/Api";
import { sectors, neighborhood } from "shared/services/PlacesService";

export default class OvitrampMovList extends React.Component {
  columns = [
    {
      name: "Cód. Ovitrampa",
      selector: "ovitrampa.codigo",
      minWidth: "50px",
      sortable: true,
    },
    {
      name: "Data Paleta",
      selector: "dt_instalacao",
      sortable: true,
      cell: (row) => (
        <div>
          {row.dt_instalacao
            ? moment(row.dt_instalacao).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      name: "Data",
      selector: "dt_ovitrampa_movimento",
      sortable: true,
      cell: (row) => (
        <div>
          {row.dt_ovitrampa_movimento
            ? moment(row.dt_ovitrampa_movimento).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      name: "Situação",
      selector: "Situação",
      sortable: true,
      cell: (row) => <div>{row.situacao ? row.situacao : ""}</div>,
    },
    {
      name: "Semana",
      selector: "ds_semana_movimento",
      sortable: true,
    },
    {
      name: "Lado",
      selector: "ds_lado",
      sortable: true,
    },
    {
      name: "Status",
      selector: "tp_status",
      sortable: true,
      cell: (row) => (
        <div>{row.tp_status ? row.tp_status : "NÂO PROCESSADO"}</div>
      ),
    },
    {
      name: "ovos_viaveis_IA",
      selector: "nr_ovos_viaveis_ia",
      sortable: true,
    },
    {
      name: "ovos_inviaveis_IA",
      selector: "nr_ovos_inviaveis_ia",
      sortable: true,
    },
    {
      name: "ovos_eclodidos_IA",
      selector: "nr_ovos_eclodidos_ia",
      sortable: true,
    },
    {
      name: "ovos_viaveis_LAB",
      selector: "nr_ovos_viaveis_lab",
      sortable: true,
    },
    {
      name: "ovos_inviaveis_LAB",
      selector: "nr_ovos_inviaveis_lab",
      sortable: true,
    },
    {
      name: "ovos_eclodidos_LAB",
      selector: "nr_ovos_eclodidos_lab",
      sortable: true,
    },
    {
      name: "",
      center: true,
      cell: (row) => (
        <div>
          {row.tp_status === "PROCESSADO" ? (
            <>
              <Button
                type="button"
                className="btn-acao"
                title="Editar"
                onClick={() => {
                  this.props.history.push("/admin/laboratorio-edit", {
                    ovitramp: row,
                  });
                }}
              >
                <FontAwesomeIcon icon={faEdit} className="edit" />
              </Button>
              {!this.state.requesting &&
                localStorage.getItem("perm") === "coordenador" && (
                  <Button
                    type="button"
                    className="btn-acao"
                    title="Remover"
                    onClick={() => {
                      this.handleDelete(row);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className="remove" />
                  </Button>
                )}
            </>
          ) : row.tp_status !== "PROCESSADO" ? (
            <span>Aguardando Processamento</span>
          ) : null}
        </div>
      ),
    },
  ];

  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };

  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  constructor(props) {
    super(props);
    moment.updateLocale("pt-br", {
      week: {
        dow: 0,
        doy: 3,
      },
    });
    this.state = {
      response: "",
      nome: "",
      bairro: "",
      logradouro: "",
      tel: "",
      api: Api.baseURL,
      id: "",
      setor: "",
      requesting: false,
      neighborhood: [],
      sectors: [],
      selectedSector: null,
      selectedNeighborhood: null,
      situacao: "",
      status: "ativo",
      tipo: "",
      codigo: null,
      ovosmax: null,
      ovosmin: null,
      ovos_aeg_min: "",
      ovos_aeg_max: "",
      ovos_alb_min: "",
      ovos_alb_max: "",
      ovos_larva_min: "",
      ovos_larva_max: "",
      ovos_culex_min: "",
      ovos_culex_max: "",
      selectedWeek: moment().week(),
      selectedYear: moment().year(),
    };
  }

  componentWillMount() {

    

    
    document.addEventListener("keydown", (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.handleSubmit(event);
      }
    });

    neighborhood().then((res) => {
      if (res) {
        this.setState({
          neighborhood: res,
        });
      }
    });

    sectors().then((res) => {
      if (res) {
        this.setState({
          sectors: res,
        });
      }
    });
    this.handleSubmit({ preventDefault: () => {} });
  }

  toNormalCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\S/g, function (match) {
      return match.toUpperCase();
    });
  }

  fetchSectors = async () => {
    const response = await fetch(Api.baseURL + "/setor", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        sectors: body,
      });
    }

    return body;
  };

  fetchNeighborhood = async () => {
    const response = await fetch(Api.baseURL + "/bairro", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        neighborhood: body,
      });
    }

    return body;
  };

  handleSubmit = (event) => {
    if (this.validate()) {
      this.setState({ response: "", requesting: true });
      this.fetchOvitramp()
        .then((res) => {
          this.setState({ response: res.data }, () => {
            const compressed = LZString.compressToUTF16(
              JSON.stringify(res.data)
            );
            localStorage.setItem("gridovilab", compressed);
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            swal: {
              show: true,
              title: "Atenção",
              text: "Não foram encontradas ovitrampas para os parâmetros informados.",
              type: "error",
            },
            requesting: false,
          });
        });
      event.preventDefault();
    }
  };

  fetchOvitramp = async () => {
    let host = this.state.api + "/movimento_ovitrampa?";

    const { selectedYear, selectedWeek } = this.state;
    const data_inicio = moment()
      .year(selectedYear)
      .week(selectedWeek)
      .startOf("week")
      .format("YYYY-MM-DD");
    const data_fim = moment()
      .year(selectedYear)
      .week(selectedWeek)
      .endOf("week")
      .format("YYYY-MM-DD");

    let params = {
      codigo: this.state.codigo !== null ? this.state.codigo.trim() : "",
      data_inicio: data_inicio,
      data_fim: data_fim,
      status: this.state.status,
    };
    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (Array.isArray(body.data)) {
      this.setState({
        agent: body.data,
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Não foram encontradas ovitrampas para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }
    return body;
  };

  validate() {
    if (this.state.tipo !== "") {
      if (this.state.ovosmax != null && this.state.ovosmin != null) {
        var diffovos = this.state.ovosmax < this.state.ovosmin;

        if (diffovos) {
          this.setState({
            swal: {
              show: true,
              title: "Atenção",
              text: "Qtde Máxima menor que Qtde Mínima",
              type: "error",
            },
          });
          return false;
        }
      }

      if (this.state.tipo === "aedes_aegypti") {
        this.setState({
          ovos_aeg_min: this.state.ovosmin,
          ovos_aeg_max: this.state.ovosmax,
          ovos_alb_min: "",
          ovos_alb_max: "",
          ovos_larva_min: "",
          ovos_larva_max: "",
          ovos_culex_min: "",
          ovos_culex_max: "",
        });
      }

      if (this.state.tipo === "aedes_albobictus") {
        this.setState({
          ovos_alb_min: this.state.ovosmin,
          ovos_alb_max: this.state.ovosmax,
          ovos_aeg_min: "",
          ovos_aeg_max: "",
          ovos_larva_min: "",
          ovos_larva_max: "",
          ovos_culex_min: "",
          ovos_culex_max: "",
        });
      }

      if (this.state.tipo === "larvas") {
        this.setState({
          ovos_larva_min: this.state.ovosmin,
          ovos_larva_max: this.state.ovosmax,
          ovos_aeg_min: "",
          ovos_aeg_max: "",
          ovos_alb_min: "",
          ovos_alb_max: "",
          ovos_culex_min: "",
          ovos_culex_max: "",
        });
      }

      if (this.state.tipo === "outros") {
        this.setState({
          ovos_culex_min: this.state.ovosmin,
          ovos_culex_max: this.state.ovosmax,
          ovos_aeg_min: "",
          ovos_aeg_max: "",
          ovos_alb_min: "",
          ovos_alb_max: "",
          ovos_larva_min: "",
          ovos_larva_max: "",
        });
      }
    }

    return true;
  }

  confirmDelete = async () => {
    return Swal.fire({
      title: "Atenção",
      text: "Deseja realmente excluir?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    });
  };

  confirmPassword = async () => {
    return Swal.fire({
      title: "Digite a senha para apagar este registro!",
      input: "password",
      showCancelButton: true,
      preConfirm: (senha) => {
        if (senha !== "zoonoses34") {
          Swal.showValidationMessage("Senha incorreta!");
          return false;
        }
        return true;
      },
    });
  };

  handleDelete = async (element) => {
    const confirm1 = await this.confirmDelete();
    if (!confirm1.value) return;
    const confirm2 = await this.confirmPassword();
    if (!confirm2.value) return;
    await this.callDel(element);
  };

  handleDeleteTireShop(d) {
    Swal.fire({
      title: "Confirme a exclusão",
      text: "Digite a senha para continuar:",
      input: "password",
      inputPlaceholder: "Digite a senha",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      preConfirm: (senhaDigitada) => {
        if (senhaDigitada !== "senha123") {
          Swal.showValidationMessage("Senha incorreta!");
          return false;
        }
        return true;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.callDel(d)
          .then()
          .catch((err) => console.log(err));
      }
    });
  }

  callDel = async (d) => {
    const response = await fetch(Api.baseURL + "/movimento_ovitrampa/" + d.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: "Ovitrampa deletada com sucesso!",
          type: "success",
        },
        response: "",
        nome: "",
        logradouro: "",
        tel: "",
        selectedNeighborhood: "",
        selectedSector: "",
        codigo: "",
        situacao: "",
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Erro ao deletar ovitrampa.",
          type: "error",
        },
      });

      throw Error(body.message);
    }

    return body;
  };

  handleWeekChange = (e) => {
    this.setState({ selectedWeek: parseInt(e.target.value, 10) });
  };

  handleYearChange = (e) => {
    this.setState({ selectedYear: parseInt(e.target.value, 10) });
  };

  generateYearOptions = () => {
    const startYear = 2025;
    const currentYear = moment().year();
    const options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };

  generateWeekOptions = () => {
    const weeksInYear = moment().year(this.state.selectedYear).weeksInYear();
    const options = [];
    for (let i = 1; i <= weeksInYear; i++) {
      options.push(
        <option key={i} value={i}>{`Semana ${i}`}</option>
      );
    }
    return options;
  };

  render() {
    const { selectedYear, selectedWeek } = this.state;
    const startDate = moment()
      .year(selectedYear)
      .week(selectedWeek)
      .startOf("week")
      .format("DD/MM/YYYY");
    const endDate = moment()
      .year(selectedYear)
      .week(selectedWeek)
      .endOf("week")
      .format("DD/MM/YYYY");
    const dateRangeText = `Período: ${startDate} e ${endDate}`;

    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });

            if (this.state.isConfirmation && !result.dismiss) {
              this.setState({
                isConfirmation: false,
              });
              this.handleDeleteOvitramp(this.state.ovitramp);
            }
          }}
        />

        <Header />
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Consulta Movimento Ovitrampas
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Código Ovitrampa
                            </label>

                            <Input
                              onlydigits
                              className="form-control"
                              id="input-id"
                              type="text"
                              placeholder=""
                              value={this.state.codigo}
                              onChange={(e) =>
                                this.setState({ codigo: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="select-year"
                            >
                              Ano
                            </label>
                            <Input
                              type="select"
                              name="ano"
                              id="select-year"
                              className="form-control"
                              value={this.state.selectedYear}
                              onChange={this.handleYearChange}
                            >
                              {this.generateYearOptions()}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col lg="5">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="select-week"
                            >
                              Semana Epidemiológica
                            </label>
                            <Input
                              type="select"
                              name="semana"
                              id="select-week"
                              className="form-control"
                              value={this.state.selectedWeek}
                              onChange={this.handleWeekChange}
                            >
                              {this.generateWeekOptions()}
                            </Input>
                            <small className="form-text text-muted mt-1">
                              {dateRangeText}
                            </small>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div className="text-center">
                      <Row>
                        <Col className="order-xl-1" xl="12">
                          {" "}
                          <Button
                            className="mt-4 btn-zoo-alt"
                            color="primary"
                            type="button"
                            onClick={this.handleSubmit}
                          >
                            <b>Pesquisar</b>
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.response && !this.state.requesting && (
            <DataTable
              noHeader={true}
              pagination={true}
              striped={true}
              columns={this.columns}
              responsive={true}
              highlightOnHover={true}
              data={this.state.response}
              paginationComponentOptions={this.defaultComponentOptions}
              paginationPerPage={8}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
              customStyles={this.customStyles}
              progressPending={this.state.response === undefined}
              noDataComponent="Nenhum registro encontrado."
              paginationResetDefaultPage={this.state.response.length > 0}
            />
          )}
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
      </>
    );
  }
}